import { ref } from 'vue'

import type { Ref } from 'vue'

import type { PersonalPickupDetailResponse, PersonalPickupListItemResponse } from '@/api/schemas/shipments/personalPickups'
import type { PersonalPickupsFilters } from '@/types/domain/shipments/personalPickups'

export const createInitialFilters = (): PersonalPickupsFilters => {
    return {}
}

export type PersonalPickupsState = {
    personalPickups: Ref<PersonalPickupListItemResponse[]>
    personalPickupsLoading: Ref<boolean>
    filters: Ref<PersonalPickupsFilters>
    prefetchedPersonalPickup: Ref<PersonalPickupDetailResponse | null>
}

export function createPersonalPickupsState(): PersonalPickupsState {
    return {
        personalPickups: ref<PersonalPickupListItemResponse[]>([]),
        personalPickupsLoading: ref(false),
        filters: ref<PersonalPickupsFilters>(createInitialFilters()),
        prefetchedPersonalPickup: ref<PersonalPickupDetailResponse | null>(null)
    }
}
